import React from 'react'

export default function Home() {
  return (
    <div className="container-fluid p-3 vh-100 overflow-hidden">
      <div className="row g-0 h-100">
        <div className="col-6 h-50 d-flex">
          <button className="btn btn-primary w-100 h-h-95 rounded m-1 fs-3 fw-bold">
            Syllabus
          </button>
        </div>
        <div className="col-6 h-50 d-flex">
          <button className="btn btn-success w-100 h-95 rounded m-1 fs-3 fw-bold">
            Routine
          </button>
        </div>
        <div className="col-6 h-50 d-flex">
          <button className="btn btn-warning w-100 h-100 rounded m-1 fs-3 fw-bold" style={{color: 'white'}}>
            Notices
          </button>
        </div>
        <div className="col-6 h-50 d-flex" >
          <button className="btn btn-danger w-100 h-100 rounded m-1 fs-3 fw-bold">
            Solutions
          </button>
        </div>
      </div>
    </div>
  )
}
